export const blockIconsDeviceSignalCellularAlt = (
	<span className='material-symbols-outlined'>signal_cellular_alt</span>
);
